<div>
    

    <p-table [value]="consumos" [lazy]="true" (onLazyLoad)="loadConsumo($event)" [paginator]="true" [rows]="100" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [rowsPerPageOptions]="[20, 50, 100]" [totalRecords]="totalRecords" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"  [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  #dt>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="cdEmpresaErp">Empresa ERP <p-sortIcon field="cdEmpresaErp"></p-sortIcon></th>
            <th pSortableColumn="cdFilialErp">Filial ERP <p-sortIcon field="cdFilialErp"></p-sortIcon></th>
            <th pSortableColumn="dtRefer">Data Referência <p-sortIcon field="dtRefer"></p-sortIcon></th>
            <th pSortableColumn="cdMaterialErp">Material ERP <p-sortIcon field="cdMaterialErp"></p-sortIcon></th>
            <th pSortableColumn="cdEquiptoErp">Equipamento ERP <p-sortIcon field="cdEquiptoErp"></p-sortIcon></th>
            <th pSortableColumn="cdCcustoErp">Centro Custo Movimento <p-sortIcon field="cdCcustoErp"></p-sortIcon></th>
            <th pSortableColumn="qtConsumo">Consumo <p-sortIcon field="qtConsumo"></p-sortIcon></th>
            <th pSortableColumn="cdUnidadeErp">Unidade ERP <p-sortIcon field="cdUnidadeErp"></p-sortIcon></th>
            <th pSortableColumn="vlCustoTotal">Custo Total <p-sortIcon field="vlCustoTotal"></p-sortIcon></th>
            <th pSortableColumn="dtRecebido">Data Recebido <p-sortIcon field="dtRecebido"></p-sortIcon></th>
            <th pSortableColumn="fgStatusInteg">Status Integração <p-sortIcon field="fgStatusInteg"></p-sortIcon></th>
            <th pSortableColumn="dtIntegPims">Data Integração PIMS <p-sortIcon field="dtIntegPims"></p-sortIcon></th>
            <th pSortableColumn="deMensagemInteg">Mensagem Integração <p-sortIcon field="deMensagemInteg"></p-sortIcon></th>
            <th pSortableColumn="cdOrdem">Ordem <p-sortIcon field="cdOrdem"></p-sortIcon></th>
            <th pSortableColumn="cdContaContabil">Conta Contábil <p-sortIcon field="cdContaContabil"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-consumo>
          <tr>
            <td>{{ consumo.cdEmpresaErp }}</td>
            <td>{{ consumo.cdFilialErp }}</td>
            <td>{{ consumo.dtRefer | date: 'dd/MM/yyyy' }}</td>
            <td>{{ consumo.cdMaterialErp }}</td>
            <td>{{ consumo.cdEquiptoErp }}</td>
            <td>{{ consumo.cdCcustoErp }}</td>
            <td>{{ consumo.qtConsumo.toLocaleString("pt-BR") }}</td>
            <td>{{ consumo.cdUnidadeErp }}</td>
            <td>{{ consumo.vlCustoTotal.toLocaleString("pt-BR") }}</td>
            <td>{{ consumo.dtRecebido | date: 'dd/MM/yyyy' }}</td>
            <td><app-tag-status [status]="consumo.fgStatusInteg"></app-tag-status></td>
            <td>{{ consumo.dtIntegPims | date: 'dd/MM/yyyy' }}</td>
            <td>{{ consumo.deMensagemInteg }}</td>
            <td>{{ consumo.cdOrdem }}</td>
            <td>{{ consumo.cdContaContabil }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <td colspan="21">Nenhum registro encontrado</td>
      </ng-template>
      </p-table>
</div>